import React, { useRef, useState } from 'react'
import { Card, CardContent, CardHeader, makeStyles, Typography, Fab, Snackbar, IconButton, Grid, CardActions, Collapse, Button, Box, Tooltip, MenuItem, Menu, Divider, CircularProgress } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add';
import { flagWordAsset, getWordPacket, removeFromCurrent3 } from '../../actions';
import { useDispatch, useSelector } from 'react-redux';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import Alert from '@material-ui/lab/Alert';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';
import ArrowForwardIosRoundedIcon from '@material-ui/icons/ArrowForwardIosRounded';

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: "350px",

    },
    rootBlur: {
        minHeight: '350px',
        filter: 'blur(8px)'
    },
    cardHeader: {
        backgroundColor:
            theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
        padding: '30px 0px'
    },
    nullCard: {
        minHeight: "350px",
        border: '1px solid',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'

    },
    definition: {
        marginTop: '5px',
        marginBottom: '50px'
    },
    centerCard: {
        minHeight: "350px",
        position: 'relative',
        bottom: '40px'
    },
    centerNullCard: {
        minHeight: "350px",
        height: '100%',
        border: '1px solid',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        bottom: '50px'

    }, bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.5)'
    },
    reportButton: {
        marginLeft: 'auto',

    }, examples: {
        marginTop: '30px',
        marginBottom: '40px'
    }, cardFooter: {
        backgroundColor:
            theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[600],
        padding: '30px 30px'
    }, examplesButton: {
        margin: '0px 0px 0px 10px',
        color: theme.palette.grey[400]
    },
    dividerThicker: {
        margin: "3px 0px 3px",
        transform: 'scale(5.3)'
    }


}));
const capitalize = (word) => {
    if (typeof word !== 'string') return null;
    return word[0].toUpperCase() + word.slice(1);

}




const WordCard = ({ word, handleDialogOpen, isCenterCard, handleClose, shouldBlur, isFrontOfCard = false }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const wordPacket = useSelector(state => state.wordPacket);
    const [isSnackBarOpen, toggleSnackBar] = useState(false);
    const [errorSeverity, setErrorSeverity] = useState('error');
    const [messageFromError, setMessageFromError] = useState('');
    const audioFile = useRef(null);
    const bull = <span className={classes.bullet}>•</span>
    const [expanded, setExpanded] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [exampleNumb, setExampleNumb] = React.useState(0);


    if (isFrontOfCard) {
        if (!word) {
            return (
                <Card className={isCenterCard ? classes.centerNullCard : classes.nullCard}>
                    <CircularProgress />
                </Card>
            )
        }

        return (

            <Card className={isCenterCard ? classes.centerNullCard : classes.nullCard}>
                <Typography variant='h4'>{capitalize(word.word)}</Typography>
            </Card>

        )

    }


    const goGetWordPacket = async () => {

        try {
            await dispatch(getWordPacket());

        } catch (error) {
            if (error.response) {
                if (error.response.data) {
                    if (error.response.data.message) {
                        setMessageFromError(error.response.data.message);
                        setErrorSeverity('error')
                        handleClose();
                        toggleSnackBar(true);
                    }
                }
            }
        }
    }

    const handleExpandClick = (event) => {
        event.stopPropagation();
        setExpanded(!expanded);
    };

    const handleReportOpenClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleReportClose = async (event, message) => {
        event.stopPropagation();
        if (!message) {
            setAnchorEl(null);
            return;
        }
        setAnchorEl(null);
        if (word?.flagged === true) {
            setMessageFromError('Word has already been flagged.');
            setErrorSeverity('warning');
            toggleSnackBar(true);
            return;
        }
        if (!message) {
            setMessageFromError("Something went wrong. Maybe let the developer know what happened so you can fix it. Tell him error code 4692690, I'm just kidding that number means nothing.");
            setErrorSeverity('warning');
            toggleSnackBar(true);

        }
        setErrorSeverity("success");
        setMessageFromError("Word has successfully been flagged.");
        await dispatch(flagWordAsset(word.word, message));
        toggleSnackBar(true);

    };

    const incrementExampleNumb = (e) => {
        e.stopPropagation();

        if (exampleNumb === word.examples.length - 1) return;
        setExampleNumb(exampleNumb + 1);
    }

    const decrementExampleNumb = (e) => {
        e.stopPropagation();
        if (exampleNumb === 0) return;
        setExampleNumb(exampleNumb - 1);
    }




    //* This method is used to populate the word Packet if it doesn't have enough data
    const populateWordPacket = () => {
        if (wordPacket.wordsPacket.length <= 0) {
            goGetWordPacket();
        } else if (wordPacket.wordOfTheDay === null || !wordPacket.wordOfTheDay) {

        } else if (wordPacket.wordOfTheDay.word === '') {
            goGetWordPacket();
        }


    }
    const convertStarToBullet = (word) => {
        if (!word) {
            return "send me screenshot if you see this.";
        }
        let wordArr = word?.split('*');
        let bulletedWord = wordArr.map(element => { if (element === wordArr[wordArr.length - 1]) { return <Box component='span' key={element}>{element}</Box> } return (<Box component='span' key={element}>{element}{bull}</Box>) })

        return bulletedWord;

    }



    const renderSnackBar = () => {
        return (
            <Snackbar open={isSnackBarOpen} autoHideDuration={6000} onClose={() => toggleSnackBar(false)}>
                <Alert severity={errorSeverity} onClose={() => toggleSnackBar(false)} >
                    {messageFromError}
                </Alert>
            </Snackbar>
        )
    }



    return (
        <React.Fragment>
            {!word ?
                <Card className={isCenterCard ? classes.centerNullCard : classes.nullCard}>
                    <Fab
                        color='primary'
                        size="large"
                        onClick={() => {
                            populateWordPacket();
                            handleDialogOpen();
                        }
                        } >
                        <AddIcon />
                    </Fab>
                </Card>


                :
                <Box className={shouldBlur ? classes.rootBlur : null}>
                    <Card className={isCenterCard ? classes.centerCard : classes.root} variant="outlined">
                        <CardHeader className={classes.cardHeader} title={capitalize(word.word)} titleTypographyProps={{ align: 'center' }}>

                        </CardHeader>

                        <CardContent>

                            <Typography variant='h6' >
                                {convertStarToBullet(word?.pronunciation)}
                            </Typography>
                            <Grid container justify='space-between' alignItems='center'>
                                <Grid>
                                    <Typography color='textSecondary'>

                                        {word.partOFSpeech}
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <IconButton color='primary' onClick={(event) => { event.stopPropagation(); audioFile.current.play(); }}>

                                        <VolumeUpIcon />

                                    </IconButton>
                                </Grid>
                            </Grid>
                            <Typography >
                                {word.partOfSpeech}
                            </Typography>
                            <Typography className={classes.definition} variant="body1" component="p">
                                {word.definition}
                            </Typography>

                            <audio ref={audioFile} src={word.audioURL} > </audio>
                        </CardContent>
                        <CardActions disableSpacing>
                            <Button size="small" className={classes.examplesButton} onClick={handleExpandClick} variant='outlined' >
                                {expanded ? 'Hide Examples' : 'Show Examples'}
                            </Button>
                            <Tooltip placement="top" title="Report something is Broken with this definition.">
                                <IconButton onClick={handleReportOpenClick} className={classes.reportButton} aria-label="report problem">
                                    <MoreVertIcon />
                                </IconButton>
                            </Tooltip>

                        </CardActions>


                        <Collapse in={expanded} timeout="auto" unmountOnExit>
                            <CardContent className={classes.cardFooter}>
                                <Grid container justify='space-around' alignItems='center'>

                                    <Grid item sm={12}>
                                        <Typography className={classes.examples} variant="body2">
                                            {word.examples.length === 0 ? "This word has no examples, Soooorry." : word.examples[exampleNumb]}
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={2}>
                                        <IconButton onClick={(e) => decrementExampleNumb(e)} disabled={exampleNumb === 0 ? true : false}>
                                            <ArrowBackIosRoundedIcon />
                                        </IconButton>
                                    </Grid>
                                    <Grid item sm={2}>
                                        <IconButton onClick={(e) => incrementExampleNumb(e)} disabled={word.examples.length - 1 === exampleNumb ? true : false}>
                                            <ArrowForwardIosRoundedIcon />
                                        </IconButton>
                                    </Grid>

                                </Grid>
                            </CardContent>
                        </Collapse>
                        <Menu
                            id="simple-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={(event) => handleReportClose(event)}
                        >
                            <MenuItem onClick={(event) => handleReportClose(event, 'Reported bad word')}>Report bad word</MenuItem>
                            <MenuItem onClick={(event) => handleReportClose(event, 'Reported bad definition')}>Report bad definition</MenuItem>
                            <MenuItem onClick={(event) => handleReportClose(event, 'Reported bad example')}>Report bad example</MenuItem>
                            <MenuItem onClick={(event) => handleReportClose(event, 'Reported bad audio')}>Report bad audio</MenuItem>
                            <MenuItem onClick={(event) => handleReportClose(event, 'Reported other')}>Report other inconsistency</MenuItem>
                            <Divider className={classes.dividerThicker} />
                            <MenuItem onClick={(event) => { handleReportClose(event); dispatch(removeFromCurrent3(word.word)) }}>Remove from Current 3</MenuItem>

                        </Menu>
                    </Card>
                </Box>
            }
            {renderSnackBar()}
        </React.Fragment>

    )
}



export default WordCard
